import { render, staticRenderFns } from "./AddToWishlist.vue?vue&type=template&id=55e80c8e&scoped=true&"
import script from "./AddToWishlist.vue?vue&type=script&lang=js&"
export * from "./AddToWishlist.vue?vue&type=script&lang=js&"
import style0 from "./AddToWishlist.vue?vue&type=style&index=0&id=55e80c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e80c8e",
  null
  
)

export default component.exports